module.exports = __webpack_public_path__ + "img/big_1_38.5d12ae92.png";